import { useState } from 'react';
import { FieldErrors } from 'react-hook-form';
import { CollapsiblePanelProps } from '../components/offer-form-section/offer-form-section';
import { OfferFormValues } from '../components/offer-form/offer-form.schema';
import { OfferFormPanel } from '../constants/offer-form-panel.enum';
import { getPanelsToOpenForErrors, INITIALLY_OPEN_PANELS } from '../lib/offer-form-panels';

/** Open state of the collapsible form parts – shared by the offer and the correction form. */
export const useOfferFormPanels = () => {
  const [openPanels, setOpenPanels] = useState<OfferFormPanel[]>(INITIALLY_OPEN_PANELS);

  const openPanelsFor = (panels: OfferFormPanel[]) => setOpenPanels((prev) => [...prev, ...panels.filter((panel) => !prev.includes(panel))]);

  const panelProps = (panel: OfferFormPanel): CollapsiblePanelProps => ({
    isOpen: openPanels.includes(panel),
    onOpenChange: (isOpen) => (isOpen ? openPanelsFor([panel]) : setOpenPanels((prev) => prev.filter((open) => open !== panel)))
  });

  // A collapsed part would hide its errors – open every part that holds one.
  const handleInvalid = (errors: FieldErrors<OfferFormValues>) => openPanelsFor(getPanelsToOpenForErrors(errors));

  return { panelProps, openPanelsFor, handleInvalid };
};
